import { Map } from "immutable";

const migrateProjectFilters = (state) => {
  const { projectFilters } = state;

  if (projectFilters) {
    let newProjectFilters = Map();

    projectFilters.toArray().forEach((item) => {
      let projectId = item.get(`projectId`);
      let filters = item.get(`filters`);

      if (projectId && filters) {
        newProjectFilters = newProjectFilters.set(`${projectId}`, Map({ filters }));
      }
    });

    return {
      ...state,
      projectFilters: newProjectFilters,
    };
  }

  return { ...state };
};

export default migrateProjectFilters;
